"use client";

import type { UseOpenApiMutationOptions } from "@packages/sdk";
import { useOpenApiMutation, useQueryClient } from "@packages/sdk";

import { keyMeRelatedAccounts } from "./useRequestMeRelatedAccounts";

const urlBackendPath = "/kids/{id}" as const;

export const useRequestKidsDelete = ({
  onSuccess,
  ...props
}: Partial<
  UseOpenApiMutationOptions<typeof urlBackendPath, "DELETE">
> = {}) => {
  const queryClient = useQueryClient();

  return useOpenApiMutation({
    method: "DELETE",
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: keyMeRelatedAccounts() });
      onSuccess?.(data, variables, context);
    },
    urlBackendPath,
    ...props,
  });
};
